var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0577 4.9425L11.2502 4.125L13.0577 3.3075L13.8752 1.5L14.6927 3.3075L16.5002 4.125L14.6927 4.9425L13.8752 6.75L13.0577 4.9425ZM15.9602 9.54L15.3752 8.25L14.7902 9.54L13.5002 10.125L14.7902 10.71L15.3752 12L15.9602 10.71L17.2502 10.125L15.9602 9.54ZM12.1802 10.7775L13.6352 11.88L11.7602 15.1275L10.0802 14.4225C9.93023 14.52 9.76523 14.6175 9.60023 14.7L9.37523 16.5H5.62523L5.40023 14.6925C5.23523 14.61 5.07773 14.52 4.92023 14.415L3.24023 15.12L1.36523 11.8725L2.82023 10.77C2.81273 10.6875 2.81273 10.59 2.81273 10.5C2.81273 10.41 2.81273 10.3125 2.82023 10.2225L1.36523 9.12L3.24023 5.8725L4.92023 6.5775C5.07023 6.48 5.23523 6.3825 5.40023 6.3L5.62523 4.5H9.37523L9.60023 6.3075C9.76523 6.39 9.92273 6.48 10.0802 6.585L11.7602 5.88L13.6352 9.1275L12.1802 10.23C12.1877 10.32 12.1877 10.41 12.1877 10.5075C12.1877 10.605 12.1877 10.6875 12.1802 10.7775ZM9.75023 10.5C9.75023 9.255 8.74523 8.25 7.50023 8.25C6.25523 8.25 5.25023 9.255 5.25023 10.5C5.25023 11.745 6.25523 12.75 7.50023 12.75C8.74523 12.75 9.75023 11.745 9.75023 10.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiSettings);
export default __webpack_public_path__ + "static/media/ai-settings.ccb6590a20b9b52a212fbe1688f70e63.svg";
export { ForwardRef as ReactComponent };